import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { useStyles } from './styles';
import SpinnerLottie from '../spinnerLottie';

export function WaitSpinner (props) {
    const {
        visible = false,
        text = '',
        customUIStyles = {},
    } = props;

    const classes = useStyles({
        customUIStyles,
    });

    function render () {
        if (!visible) {
            return (<React.Fragment></React.Fragment>);
        }

        return (<Grid className={classes.spinnerSpace}>
            <Grid className={classes.spinnerText}>{text}</Grid>
            <Grid>
                <SpinnerLottie />
            </Grid>
        </Grid>);
    }
    return render();
}

WaitSpinner.propTypes = {
    visible: PropTypes.bool,
    text: PropTypes.string,
    customUIStyles: PropTypes.any,
};

export default WaitSpinner;
